import * as Yup from 'yup';
import { SendByType, SendElectronicInvoiceMethod } from '../book-and-send/types';
import { splitEmails } from '.';
import { t } from '../../../../../shared/components/l10n/l10n';
import { getDigitalSignatureEmailValidationRegex } from '../../../../e-signature/util';

export function emailOptionsValidationSchema() {
    const schema = Yup.object().shape({
        sendByType: Yup.number().required(),
        emailOptions: Yup.object().when('sendByType', {
            is: Number(SendByType.email),
            then: Yup.object().shape({
                recipients: Yup.string().test('recipients', '', emailOptionsFieldValidation()),
                recipientsCc: Yup.string().test('recipientsCc', '', emailOptionsFieldValidation()),
                recipientsBcc: Yup.string().test('recipientsBcc', '', emailOptionsFieldValidation()),
            }),
        }),
        einvoiceOptions: Yup.object().when('sendByType', {
            is: Number(SendByType.oioxml),
            then: Yup.object().shape({
                glnNumber: Yup.string()
                    .when('sendingMethod', {
                        is: value => value === SendElectronicInvoiceMethod.GlnNumber,
                        then: Yup.string().required(),
                    })
                    .nullable(),

                cvrNumber: Yup.string()
                    .when('sendingMethod', {
                        is: value => value === SendElectronicInvoiceMethod.CvrNumber,
                        then: Yup.string().required(),
                    })
                    .nullable(),
                pNumber: Yup.string()
                    .when('sendingMethod', {
                        is: value => value === SendElectronicInvoiceMethod.PNumber,
                        then: Yup.string().required(),
                    })
                    .nullable(),
            }),
        }),
        orderSendESignatureRequest: Yup.object()
            .shape({
                recipientName: Yup.string().when('signingTemplateId', {
                    is: (value: string) => !!value && value !== 'NOSIGNINGREQUIRED',
                    then: Yup.string().required(t`FORM_FIELD_LABEL_REQUIRED`),
                }),
                recipientEmail: Yup.string().when('signingTemplateId', {
                    is: (value: string) => !!value && value !== 'NOSIGNINGREQUIRED',
                    then: Yup.string()
                        .matches(getDigitalSignatureEmailValidationRegex(), t`E_SIGNATURE_VALIDAION_ERROR_EMAIL_INVALID`)
                        .email(t`E_SIGNATURE_VALIDAION_ERROR_EMAIL_INVALID`)
                        .required(t`FORM_FIELD_LABEL_REQUIRED`),
                }),
                signingTemplateId: Yup.string(),
            })
            .notRequired(),
    });
    return schema;
}

export function emailOptionsFieldValidation(): (
    this: Yup.TestContext,
    value: any
) => boolean | Yup.ValidationError | Promise<boolean | Yup.ValidationError> {
    return async function(emails) {
        const emailValidation = Yup.string().email();
        if (emails) {
            for (const email of splitEmails(emails)) {
                if (!(await emailValidation.isValid(email))) {
                    return this.createError({
                        message: t(`POPUP_INVOICEETC_ERROR_INVALIDEMAIL`, {
                            ADDRESS: email,
                        }),
                    });
                }
            }
        }
        return true;
    };
}
